import Reveal from "@/components/Reveal";

const signals = [
  { letter: "C", name: "Captación", desc: "Qué logra llamar la atención de tu consumidor.", span: "md:col-span-4", accent: "text-magenta" },
  { letter: "E", name: "Emoción", desc: "Qué deseo, identidad o sensación despierta tu marca.", span: "md:col-span-2", accent: "text-neoncyan" },
  { letter: "R", name: "Respaldo", desc: "Qué elementos generan confianza y reducen la duda.", span: "md:col-span-2", accent: "text-violet" },
  { letter: "E", name: "Evaluación", desc: "Cómo se perciben tu precio, tu oferta y tus opciones.", span: "md:col-span-4", accent: "text-magenta" },
  { letter: "B", name: "Barrera", desc: "Qué fricciones pueden detener la compra.", span: "md:col-span-2", accent: "text-neoncyan" },
  { letter: "R", name: "Recuerdo", desc: "Qué hace que tu marca permanezca en la memoria.", span: "md:col-span-2", accent: "text-violet" },
  { letter: "O", name: "Ojo digital", desc: "Qué entienden la inteligencia artificial, los buscadores y las personas sobre tu marca.", span: "md:col-span-6", accent: "text-magenta" },
];

const Signals = () => (
  <section id="senales" className="relative border-t border-white/10 bg-wine/30 py-28 md:py-40" data-testid="signals-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal className="mb-20 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="mb-6 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
            El framework
          </p>
          <h2 className="font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter md:text-7xl">
            C·E·R·E·B·R·O
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-lilac/90 md:text-base">
          Siete señales fundamentales que tu marca envía al cerebro del consumidor.
          Tres sesiones en vivo para aprender a leerlas, y a dominarlas.
        </p>
      </Reveal>

      <div className="grid gap-4 md:grid-cols-6">
        {signals.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.07} className={s.span}>
            <article
              data-testid={`signal-card-${s.name.toLowerCase().replace(" ", "-")}`}
              className="group relative h-full overflow-hidden border border-white/10 bg-black/30 p-8 transition-colors duration-500 hover:border-magenta/50 md:p-10"
            >
              <span
                aria-hidden
                className={`pointer-events-none absolute -right-4 -top-10 font-display text-[10rem] font-black leading-none opacity-[0.07] transition-opacity duration-500 group-hover:opacity-[0.16] md:text-[13rem] ${s.accent}`}
              >
                {s.letter}
              </span>
              <p className="mb-8 font-display text-xs font-bold uppercase tracking-[0.3em] text-lilac/60">
                Señal 0{i + 1}
              </p>
              <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight md:text-3xl">
                <span className={s.accent}>{s.letter}</span>
                {s.name.slice(1)}
              </h3>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-lilac/90">{s.desc}</p>
              <span className="mt-8 block h-px w-12 bg-white/20 transition-[width,background-color] duration-500 group-hover:w-24 group-hover:bg-magenta" />
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Signals;
